<script setup lang="ts">
import FormInput from '@tix/ds/components/atoms/FormInput.vue'

import GiftAidIcon from '@/components/icons/GiftAidIcon.vue'

type Props = {
  id: string
  label: string
  disabled?: boolean
}

const model = defineModel<boolean>()

const props = defineProps<Props>()
</script>

<template>
  <div class="gift-aid-field">
    <GiftAidIcon class="gift-aid-field-icon" />
    <h3 class="visually-hidden">Gift Aid your order</h3>
    <p class="gift-aid-field-description">
      Support Ticketure by choosing to Gift Aid your order at <strong>no extra cost to you.</strong>
    </p>
    <FormInput
      :id="props.id"
      v-model="model"
      class="gift-aid-field-checkbox"
      :disabled="props.disabled"
      :label="props.label"
      type="checkbox"
    />
  </div>
</template>

<style scoped>
.gift-aid-field {
  --_text-color: var(--black-a-950);

  color: var(--_text-color);
  display: flex;
  flex-direction: column;
  gap: var(--space-0-75);
  padding: var(--space-1-5);
  background-color: #f9f5e4;
  border-radius: var(--radius-medium);

  .gift-aid-field-icon {
    width: 100px;
    height: auto;
    fill: var(--_text-color);
  }

  .gift-aid-field-description {
    margin: 0;
    font-size: var(--font-size-body);
    line-height: var(--line-height-body);
    color: var(--_text-color);
  }

  .gift-aid-field-checkbox {
    & :deep(label) {
      color: var(--_text-color);
    }

    & :deep(input:not(:checked)) {
      background-color: white;
    }
  }
}
</style>
